import { turbolandnigQuery } from '../../graphql/queries/grid/domain';
import { turboRecomendationQuery } from '../../graphql/queries/grid/turbo';
import {
    GdAdOrderByFieldInput,
    GdStatPresetInput,
    OrderInput,
    TurbolandingQuery,
    TurboRecomendationQuery
} from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 10000;

export class TurboDataProvider extends BaseDataProvider {
    public getTurbolandings = (login: string, ids: number[]) => {
        return this.createQuery<TurbolandingQuery>(turbolandnigQuery, {
            variables: {
                login,
                filter: {
                    turbolandingIdIn: ids
                }
            }
        });
    };

    public getTurboRecommendation = (
        login: string,
        cid: number,
        bids: number[]
    ) => {
        return this.createQuery<TurboRecomendationQuery>(
            turboRecomendationQuery,
            {
                variables: {
                    login,
                    adsInput: {
                        statRequirements: {
                            preset: GdStatPresetInput.TODAY
                        },
                        orderBy: {
                            order: OrderInput.ASC,
                            field: GdAdOrderByFieldInput.BANNER_TYPE
                        },
                        limitOffset: {
                            offset: DEFAULT_OFFSET,
                            limit: DEFAULT_LIMIT
                        },
                        filter: {
                            adIdIn: bids,
                            campaignIdIn: cid
                        }
                    }
                }
            }
        ).then(response => response.data.client.ads.rowset);
    };
}
